import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static targets = [
    "customerType",
    "corporateFields",
    "issuingCountryWrapper",
    "idNumber",
    "idNumberLabel",
    "issuingCountry",
    "idNumberError",
    "issuingCountryError",
    "idNumberNotice",
    "nextOfKinSection",
    "nokMessage",
    "addNokButton",    
    "nokList",          
    "employmentDetails" 
  ]

  connect() {
    // Initial toggle based on selected customer type
    if (this.hasCustomerTypeTarget) {
      this.toggleSectionsByCustomerType()
      this.customerTypeTarget.addEventListener("change", () => this.toggleSectionsByCustomerType())
    }

    // ID number validation
    if (this.hasIdNumberTarget) {
      this.idNumberTarget.addEventListener("input", () => this.validateIdNumber())
    }

    // SlimSelect for issuing country
    if (this.hasIssuingCountryTarget) {
      new SlimSelect({ select: this.issuingCountryTarget, placeholder: "Select Country" })
    }
  }

  // -------------------------------
  // Toggle form sections based on customer type
  // -------------------------------
   toggleSectionsByCustomerType() {
  const type = this.customerTypeTarget?.selectedOptions[0]?.text?.trim().toLowerCase()
  const corporate = this.corporateFieldsTarget
  const personal = this.element.querySelector('[data-section="personal"]')
  const identification = this.element.querySelector('[data-section="identification"]')
  const nextOfKin = this.nextOfKinSectionTarget
  const employment = this.employmentDetailsTarget
  const contact = this.element.querySelector('[data-section="contact"]')
  const address = this.element.querySelector('[data-section="address"]')

    if (type === "individual") {
      // Individual → show personal info
      corporate.style.display = "none"
      personal.style.display = "block"
      identification.style.display = "block"
      employment.style.display = "block"

      nextOfKin.style.display = "block"
      this.nokMessageTarget.style.display = "none"
      this.addNokButtonTarget.style.display = "inline-block"

      if (!nextOfKin.querySelector(".nested-fields")) {
        const template = document.getElementById("next-of-kin-template")
        if (template) this.nokListTarget.insertAdjacentHTML("beforeend", template.innerHTML)
      }
    } else {
      // Corporate / Trust / Other
      corporate.style.display = "block"
      personal.style.display = "none"
      identification.style.display = "none"
      employment.style.display = "none"

      nextOfKin.style.display = "block"
      this.nokMessageTarget.style.display = "block"
      this.addNokButtonTarget.style.display = "none"
      this.nokListTarget.innerHTML = ""
}

  // Always show contact and address
  contact.style.display = "block"
  address.style.display = "block"
}



  // -------------------------------
  // Add/Remove Next of Kin
  // -------------------------------
  addNextOfKin(event) {
    event.preventDefault()
    const template = document.getElementById("next-of-kin-template")
    if (!template) return
    this.nextOfKinSectionTarget.insertAdjacentHTML("beforeend", template.innerHTML)
  }

  removeNextOfKin(event) {
    event.preventDefault()
    const button = event.currentTarget
    const nestedField = button.closest(".nested-fields")
    if (nestedField) nestedField.remove()
  }

  // -------------------------------
  // ID type change
  // -------------------------------
  idTypeChanged(event) {
    const type = event.target.value
    if (type === "passport") {
      this.issuingCountryWrapperTarget.style.display = ""
      this.idNumberLabelTarget.textContent = "Passport Number"
      this.idNumberNoticeTarget.textContent = ""
    } else {
      this.issuingCountryWrapperTarget.style.display = "none"
      this.idNumberLabelTarget.textContent = "National ID"
      this.idNumberNoticeTarget.textContent = "Format: 63-4535563N67"
      this.issuingCountryTarget.value = ""
      this.clearIssuingCountryError()
    }
    this.clearIdNumberError()
  }

  // -------------------------------
  // Validate ID number
  // -------------------------------
  validateIdNumber() {
    const type = this.element.querySelector('input[name="customer[id_type]"]:checked')?.value
    const value = this.idNumberTarget.value.trim()
    let valid = true
    this.clearIdNumberError()
    this.clearIssuingCountryError()

    if (type === "nationalid" && value) {
      const regex = /^\d{2}-\d{5,8}[A-Z]\d{2}$/i
      if (!regex.test(value)) {
        valid = false
        this.idNumberErrorTarget.textContent = "Invalid Zimbabwean ID. Example: 63-4535563N67"
        this.idNumberErrorTarget.classList.remove("d-none")
      }
    } else if (type === "passport" && value) {
      if (value.length < 3) {
        valid = false
        this.idNumberErrorTarget.textContent = "Passport number is too short."
        this.idNumberErrorTarget.classList.remove("d-none")
      }
      if (this.issuingCountryTarget.value === "") {
        valid = false
        this.issuingCountryErrorTarget.textContent = "Please select issuing country."
        this.issuingCountryErrorTarget.classList.remove("d-none")
      }
    }

    return valid
  }

  // -------------------------------
  // Form validation
  // -------------------------------
    validateForm(event) {
  const typeText = this.customerTypeTarget?.selectedOptions[0]?.text?.trim().toLowerCase()
  let valid = true

  // ✅ If NOT Individual → validate corporate style, skip NOK
  
  if (typeText !== "individual") {
    const corporateFields = ["customer_name", "registration_number", "mobile_1", "email", "address_1", "city", "country", "source_of_funds"]
    corporateFields.forEach(f => {
      const input = this.element.querySelector(`[name='customer[${f}]']`)
      if (input && input.value.trim() === "") {
        input.classList.add("is-invalid")
        valid = false
      } else if (input) {
        input.classList.remove("is-invalid")
      }
    })

    // ✅ SKIP NEXT OF KIN VALIDATION COMPLETELY
  } else {
    // ✅ Individual fields validation stays same
    const individualFields = ["firstname", "lastname", "dob", "mobile_1", "email", "address_1", "city", "country", "source_of_funds"]
    individualFields.forEach(f => {
      const input = this.element.querySelector(`[name='customer[${f}]']`)
      if (input && input.value.trim() === "") {
        input.classList.add("is-invalid")
        valid = false
      } else if (input) {
        input.classList.remove("is-invalid")
      }
    })

    if (!this.validateIdNumber()) valid = false

    // ✅ Next of Kin REQUIRED only for Individuals
    const nokFields = this.nextOfKinSectionTarget.querySelectorAll(".nested-fields input")
    if (nokFields.length === 0) {
      alert("Please add at least one Next of Kin.")
      valid = false
    }
  }

  if (!valid) {
    event.preventDefault()
    alert("Please fill in all required fields correctly before proceeding.")
  }
}


  // -------------------------------
  // Clear errors
  // -------------------------------
  clearIdNumberError() {
    if (this.hasIdNumberErrorTarget) {
      this.idNumberErrorTarget.classList.add("d-none")
      this.idNumberErrorTarget.textContent = ""
    }
  }

  clearIssuingCountryError() {
    if (this.hasIssuingCountryErrorTarget) {
      this.issuingCountryErrorTarget.classList.add("d-none")
      this.issuingCountryErrorTarget.textContent = ""
    }
  }
}
